import React, {
  useState,
  useEffect,
  useImperativeHandle,
  forwardRef,
} from "react";
import {
  Alert,
  Button,
  Card,
  Col,
  Form,
  Row,
  Modal,
  Spinner,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import toastr from "toastr";
import CustomTable from "../../components/CustomTable";
//import CustomPagination from '../../components/CustomPagination'
import messages from "../../redux/messages";
import {
  getEducation,
  saveEducation,
  editEducation,
  deleteEducation,
} from "../../redux/education/actions";
import { getFuncFormations } from "../../redux/func_formacion/actions";
import { getInstitute } from "../../redux/institute/actions";
import { getSpecialization } from "../../redux/specialization/actions";
import { getCollegeDegree } from "../../redux/collegedegree/actions";
import { requesChangesUserEducation } from "../../redux/updateUserData/actions";
import config from "../../config";
import { getSubNiveles } from "../../redux/gestorDocumental/actions";
import { getEmployee } from "../../redux/employees/actions";
import { getBase64 } from "../../components/gestorDocumental/GestorDocumental";
import LinkDescargaListGD from "../../components/gestorDocumental/LinkDescargaListGD";
import LinkDescargaGD from "../gestorDocumental/LinkDescargaGD";
import { getCountryUser } from "../../redux/countryUser/actions";
import axios from "axios";
import { Typeahead } from "react-bootstrap-typeahead";
import { toaster } from "rsuite";
import { toast } from "react-toastify";

const UserEducationComponent = (props, ref) => {
  // const [offset, setOffset] = useState(0)
  // const [limit, setLimit] = useState(10)
  // const [currentPage, setCurrentPage] = useState(1)
  const [edit, setEdit] = useState(false);
  const [index, setIndex] = useState(0);
  const [editItem, setEditItem] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [validated, setValidated] = useState(false);
  const [filterInst, setFilterInst] = useState("");
  // const [fileTemp, setFileTemp] = useState("");

  const [validFechaDoc, setValidFechaDoc] = useState(false);
  const [habilitarFecha, setHabilitarFecha] = useState(false);

  //Redux
  const dispatch = useDispatch();
  const data = useSelector((store) => store.education.education);
  //const dataLenght = useSelector(store => store.education.educationLength)
  //const pages = Math.ceil(dataLenght / limit)
  const loading = useSelector((store) => store.education.loading);
  const saveLoading = useSelector((store) => store.education.saveLoader);
  //Formations
  const formations = useSelector((store) => store.funcFormation.Formations);
  const formationsLoader = useSelector((store) => store.funcFormation.loader);
  //Especialidad
  const specializations = useSelector(
    (store) => store.specialization.specialization
  );
  const specializationsLoading = useSelector(
    (store) => store.specialization.loading
  );
  //Instituto
  const institutes = useSelector((store) => store.institute.institute);
  const institutesLoading = useSelector((store) => store.institute.loading);
  //Titul0
  const collegeDegrees = useSelector(
    (store) => store.collegeDegree.collegeDegree
  );
  const collegeDegreeLoading = useSelector(
    (store) => store.collegeDegree.loading
  );

  // const userInfo = useSelector((store) => store.employees.employee);
  const userId = useSelector((store) => store.auth.id);
  const userN = useSelector((store) => store.auth.username);
   const userOrg = useSelector((store) => store.auth.userOrg);

  const {
    // areas,
    // carpetas,
    subNiveles,
    areasError,
    carpetasError,
    error,
    formErrors,
    // docs,
    loaderSubNiveles,
    loadingDocs,
    loadingAreas,
    loadingCarpetas,
    saveDocsLoading,
    subNivelesError,
  } = useSelector((store) => store.gestorDocumental);

  const { carpeta, tipoDocumento } = config.gestorDocumental.educacion;
  const { area, email } = config.gestorDocumental;

  const columns = [
    {
      Header: "Formación",
      accessor: "formacion_list.descripcion",
    },
    {
      Header: "Especialidad",
      accessor: "especialidad_list.descripcion",
    },
    {
      Header: "Nivel de Educación",
      accessor: "instituto_list.descripcion",
      Filter: "",
    },
    {
      Header: "Nombre Instituto",
      accessor: "nombre_instituto",
      Filter: "",
    },
    {
      Header: "Título",
      accessor: "titulo_list.descripcion",
      Filter: "",
    },
    {
      id: "Fechainicio",
      Header: "Fecha de inicio",
      Filter: "",
      Cell: (value) =>
        moment(value.row.original.fecha_fin).format("DD/MM/YYYY"),
    },
    {
      id: "Fechafin",
      Header: "Fecha de fin",
      Filter: "",
      Cell: (value) =>
        moment(value.row.original.fecha_inicio).format("DD/MM/YYYY"),
    },
    {
      id: "customButtons",
      Filter: "",
      Cell: (value) => (
        <div className="btn-group d-flex align-items-center" role="group">
          <OverlayTrigger
            placement="auto"
            overlay={<Tooltip {...props}>Editar el registro</Tooltip>}
          >
            <Button
              size="sm"
              variant="link"
              type="button"
              disabled={loaderSubNiveles}
              onClick={() => onEdit(value.row.original, value.row.index)}
            >
              <i className="material-icons">edit</i>
            </Button>
          </OverlayTrigger>
          {loaderSubNiveles ? (
            <Spinner
              className="mr-2"
              as="span"
              animation="border"
              size="sm"
              role="status"
              aria-hidden="true"
            />
          ) : null}
          <OverlayTrigger
            placement="auto"
            overlay={<Tooltip {...props}>Eliminar el registro</Tooltip>}
          >
            <Button
              size="sm"
              className="text-danger"
              variant="link"
              type="button"
              disabled={props.dpt === 2}
              onClick={() => onDelete(value.row.original.id, value.row.index)}
            >
              <i className="material-icons">close</i>
            </Button>
          </OverlayTrigger>
          {value.row.original.archivo_gestor && (
            <LinkDescargaListGD
              id={value.row.original.id}
              filters={{
                email: email,
                id: value.row.original.archivo_gestor[0].id_documento,
                llave: value.row.original.archivo_gestor[0].llave,
              }}
              origen={value.row.original.archivo_gestor[0].origen}
              icono={<i className="material-icons">file</i>}
              cType={value.row.original.archivo_gestor[0].contentTypeGD}
            />
          )}
        </div>
      ),
    },
  ];

  // Métodos
  useEffect(() => {
    dispatch(
      getEducation(
        {
          empleado: parseInt(props.id),
          filter: parseInt(props.id),
        },
        parseInt(props.type)
      )
    );
  }, [dispatch, props.id, props.type]);

  useEffect(() => {
    dispatch(getInstitute({}, parseInt(props.type)));
  }, [dispatch, props.type]);

  useEffect(() => {
    dispatch(
      getFuncFormations({ instituto: filterInst }, parseInt(props.type))
    );
    dispatch(
      getSpecialization({ instituto: filterInst }, parseInt(props.type))
    );
    dispatch(getCollegeDegree({ instituto: filterInst }, parseInt(props.type)));
  }, [dispatch, filterInst, props.type]);

  const onAdd = () => {
    const oCarpeta = props.carpetas.find(
      (item) => item.descripcion.toLowerCase() === carpeta.toLowerCase()
    );
    dispatch(
      getSubNiveles({
        areaid: props.areas[0].id,
        ceid: oCarpeta.id,
      })
    );
    setHabilitarFecha(false);
    setShowModal(true);
    setEdit(false);
    setValidated(false);
    if (institutes.length > 0) {
      setFilterInst(institutes[0].id);
    }
    setspecializationsTranform(
      specializations.map((esp) => ({
        ...esp,
        label: esp.descripcion,
        item: esp.descripcion,
      }))
    );
  };

  useImperativeHandle(ref, () => ({
    onAdd,
  }));

  const onEdit = (item, index) => {
    const oCarpeta = props.carpetas.find(
      (item) => item.descripcion.toLowerCase() === carpeta.toLowerCase()
    );
    dispatch(
      getSubNiveles({
        areaid: props.areas[0].id,
        ceid: oCarpeta.id,
      })
    );
    setHabilitarFecha(false);
    setIndex(index);
    setEdit(true);
    setEditItem(item);
    setFilterInst(item.instituto);
    setShowModal(true);
    setValidated(false);
    setspecializationsTranform(
      specializations.map((esp) => ({
        ...esp,
        label: esp.descripcion,
        item: esp.descripcion,
      }))
    );
  };

  /*Paginación*/
  // const prev = () => {
  //   if(currentPage <= 0)
  //     setCurrentPage(0)
  //   else
  //     setCurrentPage(currentPage - 1)

  //   setOffset(offset - limit)
  // }

  // const next = () => {
  //   if (currentPage >= pages)
  //     setCurrentPage(pages)
  //   else
  //     setCurrentPage(currentPage + 1)

  //   setOffset(offset + limit)
  // }

  // const last = () => {
  //   setCurrentPage(pages)
  //   setOffset((pages * limit) - limit)
  // }

  // const first = () => {
  //   setCurrentPage(1)
  //   setOffset(0)
  // }

  // const onChangeLimit = value => {
  //   setLimit(parseInt(value))
  //   setOffset(0)
  //   setCurrentPage(1)
  // };

  const onSubmitAdmin = async (e) => {
    e.preventDefault();

    debugger;
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      setValidated(true);
      return;
    }

    let isValidFilePreData = true;
    let exist = e.target.documentos.files.length > 0;
    if (exist && e.target.fechaDoc.value === "") {
      isValidFilePreData = false;
    }

    if (props.areas.length === 0 || props.carpetas === 0) {
      isValidFilePreData = false;
    }

    if (!isValidFilePreData) {
      setValidFechaDoc(true);
      setValidated(true);
      return;
    }

    let educ = new FormData();
    if (exist) {
      const oArea = props.areas.find(
        (item) => item.descripcion.toLowerCase() === area.toLowerCase()
      );
      const oCarpeta = props.carpetas.find(
        (item) => item.descripcion.toLowerCase() === carpeta.toLowerCase()
      );

      try {
        const filebase64 = await getBase64(e.target.documentos.files[0]);
        const fileName = e.target.documentos.files[0].name;
        const fName = String(fileName)
          .substring(0, String(fileName).lastIndexOf("."))
          .replace(/\W/g, "");
        const fExt = `.${String(fileName).substr(
          fileName.lastIndexOf(".") + 1 - fileName.length
        )}`;
        const aFileBase = String(filebase64).split(",");

        educ.append("id_empleado", parseInt(props.id));
        educ.append("tipo_documento", tipoDocumento);
        educ.append("archivo", aFileBase[1]);
        educ.append("contentTypeGD", `${aFileBase[0]},`);
        educ.append("origen", fName + fExt);
        educ.append("extension", fExt);
        educ.append("tipo_documento_GD", e.target.tipoDocumentDesc.value);
        educ.append("descripcion", e.target.documentDesc.value);
        educ.append(
          "fecha",
          moment(e.target.fechaDoc.value).format("YYYY-MM-DD")
        );
        educ.append("id_area", oArea.id);
        educ.append("id_carpeta_encabezado", oCarpeta.id);
        educ.append("empresa", props.userInfo.empresa[0]);
        educ.append(
          "zona",
          props.userInfo.Division_Personal_List[0].descripcion
        );
      } catch (error) {
        console.log(error);
        toastr.info("Error al subir archivo");
        return;
      }
      // Fin lineas para gestor documental
    }

    const req = {
      clave_pais: e.target.countryColl.value,
      fecha_inicio: e.target.dateStart.value,
      fecha_fin: e.target.dateEnd.value,
      empleado: props.id,
      instituto: parseInt(e.target.inst.value),
      nombre_instituto: e.target.collaName.value,
      titulo: parseInt(e.target.tit.value),
      formacion: parseInt(e.target.forma.value),
      especialidad: parseInt(e.target.esp.value),
    };

    if (!edit) {
      dispatch(
        saveEducation(
          req,
          parseInt(props.type),
          educ,
          exist,
          setShowModal,
          setValidFechaDoc,
          e.target
        )
      );
    } else {
      dispatch(
        editEducation(
          req,
          editItem.id,
          index,
          parseInt(props.type),
          educ,
          editItem.archivos_gestor,
          exist,
          setShowModal,
          setValidFechaDoc
        )
      );
    }
    //setShowModal(false);
    //|setValidFechaDoc(false);
  };

  const onSubmit = async (e) => {
    e.preventDefault();

    if (selectedESP.length === 0) {
      toastr.info("Debe Seleccionar una Especialización");
      return;
    }

    const form = e.currentTarget;

    if (form.checkValidity() === false) {
      setValidated(true);
      return;
    }

    let exist = edit ? e.target.documentos.files.length > 0 : false;

    if (edit) {
      let isValidFilePreData = true;
      if (
        e.target.documentos.files.length > 0 &&
        e.target.fechaDoc.value === ""
      ) {
        isValidFilePreData = false;
      }

      if (props.areas.length === 0 || props.carpetas === 0) {
        isValidFilePreData = false;
      }

      if (!isValidFilePreData) {
        setValidFechaDoc(true);
        setValidated(true);
        return;
      }
    }

    let educ = new FormData();

    if (edit) {
      const oArea = props.areas.find(
        (item) => item.descripcion.toLowerCase() === area.toLowerCase()
      );
      const oCarpeta = props.carpetas.find(
        (item) => item.descripcion.toLowerCase() === carpeta.toLowerCase()
      );

      try {
        const filebase64 = await getBase64(e.target.documentos.files[0]);
        const fileName = e.target.documentos.files[0].name;
        const fName = String(fileName)
          .substring(0, String(fileName).lastIndexOf("."))
          .replace(/\W/g, "");
        const fExt = `.${String(fileName).substr(
          fileName.lastIndexOf(".") + 1 - fileName.length
        )}`;
        const aFileBase = String(filebase64).split(",");

        educ.append("id_empleado", parseInt(props.id));
        educ.append("tipo_documento", tipoDocumento);
        educ.append("archivo", aFileBase[1]);
        educ.append("contentTypeGD", `${aFileBase[0]},`);
        educ.append("origen", fName + fExt);
        educ.append("extension", fExt);
        educ.append("tipo_documento_GD", e.target.tipoDocumentDesc.value);
        educ.append("descripcion", e.target.documentDesc.value);
        educ.append(
          "fecha",
          moment(e.target.fechaDoc.value).format("YYYY-MM-DD")
        );
        educ.append("id_area", oArea.id);
        educ.append("id_carpeta_encabezado", oCarpeta.id);
        educ.append("empresa", props.userInfo.empresa[0]);
        educ.append(
          "zona",
          props.userInfo.Division_Personal_List[0].descripcion
        );
      } catch (error) {
        console.log(error);
        toastr.info("Error al subir archivo");
        return;
      }
      // Fin lineas para gestor documental
    }

    const req = {
      clave_pais: e.target.countryColl.value,
      fecha_inicio: e.target.dateStart.value,
      fecha_fin: e.target.dateEnd.value,
      empresa_id: userOrg
    };

    //? contenido del excel
    const instCode = institutes.find(
      (item) => item.id === parseInt(e.target.inst.value)
    );
    req.subtipo = instCode.codigo || "";
    const titCode = collegeDegrees.find(
      (item) => item.id === parseInt(e.target.tit.value)
    );
    req.titulo = titCode.codigo || "";
    const formCode = formations.find(
      (item) => item.id === parseInt(e.target.forma.value)
    );
    req.formacion = formCode.codigo || "";
    const espCode = selectedESP[0].code;
    req.especialidad = espCode && espCode.codigo ? espCode.codigo : "";
    req.codigo_empleado = userN;
    req.instituto = e.target.collaName.value;
    //req.instituto = e.target.inst.value
    const institutoT = parseInt(e.target.inst.value);
    const tituloT = parseInt(e.target.tit.value);
    dispatch(
      requesChangesUserEducation(
        req,
        props.showMessagef,
        edit,
        educ,
        index,
        editItem,
        parseInt(props.type),
        institutoT,
        tituloT,
        exist,
        setShowModal,
        setValidFechaDoc
      )
    );
  };

  const onDelete = (id, index) => {
    if (window.confirm(messages.preguntaEliminar)) {
      dispatch(deleteEducation(id, index, parseInt(props.type)));
    }
  };

  const { paises } = config.aurora;

  // pais
  useEffect(() => {
    dispatch(getCountryUser());
  }, [dispatch]);

  const countryData = useSelector((store) => store.countryUser);
  // console.log("countryData");
  // console.log(countryData);
  // esp
  const [specializationsTranform, setspecializationsTranform] = useState([]);
  const [selectedESP, setselectedESP] = useState([]);

  return (
    <>
      {loading ? (
        <div className="d-flex justify-content-center">
          <Spinner
            animation="border"
            role="status"
            className="d-flex justify-content-center"
          />
        </div>
      ) : data.length > 0 ? (
        <>
          <Card className="border-0">
            <Card.Body className="px-1 px-sm-2">
              <CustomTable columns={columns} data={data} />
            </Card.Body>
          </Card>
          {/* <CustomPagination 
              limit={limit}
              offset={offset}
              currentPage={currentPage}
              dataLenght={dataLenght}
              pages={pages}
              prev={ prev }
              next={ next }
              first={ first }
              last={ last }
              onChangeLimit={onChangeLimit} /> */}
        </>
      ) : (
        <Alert className="my-4" variant="info">
          Aún no hay registros, comienza agregando algunos
        </Alert>
      )}
      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Form
          onSubmit={props.uet === 2 ? onSubmit : onSubmitAdmin}
          noValidate
          validated={validated}
        >
          <Modal.Header closeButton>
            <Modal.Title>
              {edit ? "Editar formación" : "Crear formación"}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {!!formErrors && (
              <Alert variant="danger" className="mt-4 mb-1 mx-3">
                {formErrors}
              </Alert>
            )}
            {!!subNivelesError && (
              <Alert variant="danger" className="mt-4 mb-1 mx-3">
                {subNivelesError}
              </Alert>
            )}
            <Form.Group as={Row} className="mb-3">
              <Form.Label column sm="12" md="4">
                Nivel de educación
              </Form.Label>
              <Col sm="12" md="8">
                <Row className="align-items-center">
                  <Col sm={institutesLoading ? "10" : "12"}>
                    <Form.Control
                      as="select"
                      name="inst"
                      id="inst"
                      className="rounded-pill"
                      required
                      value={edit ? editItem.instituto : null}
                      onChange={(e) => {
                        setEditItem({ ...editItem, instituto: e.target.value });
                        setFilterInst(e.target.value);
                      }}
                      placeholder="Puesto"
                    >
                      <option
                        key="No select education level"
                        value=""
                        selected
                        disabled
                      >
                        Seleccione Nivel de Educación
                      </option>
                      {institutes.map((item) => (
                        <option key={item.id} value={item.id}>
                          {item.descripcion}
                        </option>
                      ))}
                    </Form.Control>
                    <Form.Control.Feedback type="invalid">
                      **Campo requerido
                    </Form.Control.Feedback>
                  </Col>
                  {institutesLoading && (
                    <Col sm="2">
                      <Spinner animation="border" size="sm" />
                    </Col>
                  )}
                </Row>
              </Col>
            </Form.Group>
            <Form.Group
              as={Row}
              className="mb-3 align-items-center"
              controlId="collaName"
            >
              <Form.Label column sm="12" md="4">
                Nombre de instituto
              </Form.Label>
              <Col sm="12" md="8">
                <Form.Control
                  name="collaName"
                  className="rounded-pill"
                  type="text"
                  required
                  value={edit ? editItem.nombre_instituto : null}
                  onChange={(e) =>
                    setEditItem({
                      ...editItem,
                      nombre_instituto: e.target.value,
                    })
                  }
                  pattern="[A-Za-zñÑáéíóúÁÉÍÓÚ0-9\s]+"
                  placeholder="Nombre de instituto"
                ></Form.Control>
                <Form.Control.Feedback type="invalid">
                  **Campo requerido
                </Form.Control.Feedback>
              </Col>
            </Form.Group>
            <Form.Group as={Row} className="mb-3">
              <Form.Label column sm="12" md="4">
                Formación
              </Form.Label>
              <Col sm="12" md="8">
                <Row className="align-items-center">
                  <Col sm={formationsLoader ? "10" : "12"}>
                    <Form.Control
                      as="select"
                      name="forma"
                      id="forma"
                      className="rounded-pill"
                      required
                      value={edit ? editItem.formacion : null}
                      onChange={(e) =>
                        setEditItem({ ...editItem, formacion: e.target.value })
                      }
                      placeholder="Puesto"
                    >
                      <option
                        key="No selected training"
                        value=""
                        selected
                        disabled
                      >
                        Seleccione su Formación
                      </option>
                      {formations.map((item) => (
                        <option key={item.id} value={item.id}>
                          {item.descripcion}
                        </option>
                      ))}
                    </Form.Control>
                    <Form.Control.Feedback type="invalid">
                      **Campo requerido
                    </Form.Control.Feedback>
                  </Col>
                  {formationsLoader && (
                    <Col sm="2">
                      <Spinner animation="border" size="sm" />
                    </Col>
                  )}
                </Row>
              </Col>
            </Form.Group>
            <Form.Group as={Row} className="mb-3">
              <Form.Label column sm="12" md="4">
                Titulo
              </Form.Label>
              <Col sm="12" md="8">
                <Row className="align-items-center">
                  <Col sm={collegeDegreeLoading ? "10" : "12"}>
                    <Form.Control
                      as="select"
                      name="tit"
                      id="tit"
                      disabled={collegeDegreeLoading}
                      className="rounded-pill"
                      required
                      value={edit ? editItem.titulo : null}
                      onChange={(e) =>
                        setEditItem({ ...editItem, titulo: e.target.value })
                      }
                      placeholder="Puesto"
                    >
                      {collegeDegrees.map((item) => (
                        <option key={item.id} value={item.id}>
                          {item.descripcion}
                        </option>
                      ))}
                    </Form.Control>
                    <Form.Control.Feedback type="invalid">
                      **Campo requerido
                    </Form.Control.Feedback>
                  </Col>
                  {collegeDegreeLoading && (
                    <Col sm="2">
                      <Spinner animation="border" size="sm" />
                    </Col>
                  )}
                </Row>
              </Col>
            </Form.Group>

            {/* typeahead especializaciones */}

            <Form.Group as={Row}>
              <Form.Label column sm={4}>
                Especialidad
              </Form.Label>
              <Col sm={8}>
                <Row className="d-flex flex-wrap align-items-center">
                  <Col sm={specializationsLoading ? "10" : "12"}>
                    <Typeahead
                      id="esp"
                      name="esp"
                      // isInvalid={touched.responsable && errors.responsable}
                      // isValid={touched.responsable && !errors.responsable}
                      // onBlur={handleBlur("responsable")}
                      placeholder="Seleccione una Especialidad"
                      options={specializationsTranform}
                      onChange={(selected) => {
                        console.log(selected);
                        setselectedESP(selected);
                        setEditItem({
                          ...editItem,
                          especialidad:
                            selected.length > 0 ? selected[0].id : "",
                        });
                      }}
                      selected={selectedESP}
                      disabled={
                        !!specializationsTranform == false ||
                        specializationsLoading
                      }
                    ></Typeahead>
                  </Col>
                  {specializationsLoading && (
                    <Col sm={1}>
                      <Spinner animation="border" size="sm" />
                    </Col>
                  )}
                </Row>
              </Col>
            </Form.Group>
            {/* search select fin */}

            <Form.Group as={Row} className="mb-3" controlId="countryColl">
              <Form.Label column sm="12" md="4">
                País
              </Form.Label>
              <Col sm="12" md="8">
                <Form.Control
                  as="select"
                  name="countryColl"
                  className="rounded-pill"
                  required
                  defaultValue={edit ? editItem.clave_pais : null}
                  placeholder="País de nacimiento"
                >
                  <option key="No selected country" value="" selected disabled>
                    Seleccione un País
                  </option>
                  {paises.map((item) => (
                    <option key={item.code} value={item.code}>
                      {item.name_es}
                    </option>
                  ))}
                </Form.Control>
                <datalist className="rounded-pill">
                  {paises.map((item) => (
                    <option key={item.code} value={item.code}>
                      {item.name_es}
                    </option>
                  ))}
                </datalist>
                <Form.Control.Feedback type="invalid">
                  **Campo requerido
                </Form.Control.Feedback>
              </Col>
            </Form.Group>
            <Form.Group as={Row} className="mb-3">
              <Form.Label column sm="12" md="4">
                Fecha de inicio
              </Form.Label>
              <Col sm="12" md="8">
                <Form.Control
                  name="dateStart"
                  className="rounded-pill"
                  required
                  type="date"
                  defaultValue={edit ? editItem.fecha_inicio : null}
                  placeholder="Fecha de inicio"
                ></Form.Control>
                <Form.Control.Feedback type="invalid">
                  **Campo requerido
                </Form.Control.Feedback>
              </Col>
            </Form.Group>
            <Form.Group as={Row} className="mb-3">
              <Form.Label column sm="12" md="4">
                Fecha final
              </Form.Label>
              <Col sm="12" md="8">
                <Form.Control
                  name="dateEnd"
                  className="rounded-pill"
                  required
                  type="date"
                  defaultValue={edit ? editItem.fecha_fin : null}
                  placeholder="Descripción"
                ></Form.Control>
                <Form.Control.Feedback type="invalid">
                  **Campo requerido
                </Form.Control.Feedback>
              </Col>
            </Form.Group>
            {(props.uet === 1 || edit) && (
              <>
                <span>Subir documento:</span>
                <hr className="mt-1" />
                <Form.Group className="mb-3">
                  <Form.File as={Row} id="form-doc">
                    <Form.Label column sm="12" md="4">
                      Documento
                    </Form.Label>
                    <Col sm="12" md="8">
                      <Form.File.Input
                        // accept="image/*"
                        name="documentos"
                        className="py-1"
                        // className="py-1 px-2 rounded-pill"
                        // style={{ border: "1px solid #ced4da" }}
                        required={
                          (editItem && editItem.archivo_gestor === null) ||
                          !edit
                        }
                        disabled={
                          loadingDocs ||
                          loadingAreas ||
                          loadingCarpetas ||
                          saveDocsLoading ||
                          !(
                            subNiveles &&
                            subNiveles.subNivelTipoDocList.length > 0
                          ) ||
                          !(
                            subNiveles &&
                            subNiveles.subNivelDescripcionList.length > 0
                          )
                        }
                        onChange={(e) => {
                          if (e.currentTarget.files.length > 0) {
                            setHabilitarFecha(true);
                          } else {
                            setHabilitarFecha(false);
                          }
                        }}
                      />
                      <Form.Control.Feedback type="invalid">
                        <ul className="list-unstyled">
                          <li>**Es requerido un archivo de menor peso.</li>
                          <li>
                            **Es requerido un archivo con formato pdf o imagen.
                          </li>
                        </ul>
                      </Form.Control.Feedback>
                    </Col>
                  </Form.File>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm="12" md="4">
                    Tipo de documento
                  </Form.Label>
                  <Col sm="12" md="8">
                    <Form.Control
                      as="select"
                      name="tipoDocumentDesc"
                      className="rounded-pill"
                      required={validFechaDoc}
                      // defaultValue={edit ? editItem.pais_nacimiento : null}
                      placeholder="Descripción del documento"
                      disabled={!habilitarFecha}
                    >
                      <option value="" selected disabled>
                        Seleccione un tipo de documento
                      </option>
                      {subNiveles &&
                        subNiveles.subNivelTipoDocList &&
                        subNiveles.subNivelTipoDocList.map((item, index) => (
                          <option key={index} value={item.descripcion}>
                            {item.descripcion}
                          </option>
                        ))}
                    </Form.Control>
                    <Form.Control.Feedback type="invalid">
                      **Campo requerido
                    </Form.Control.Feedback>
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm="12" md="4">
                    Descripción
                  </Form.Label>
                  <Col sm="12" md="8">
                    <Form.Control
                      as="select"
                      name="documentDesc"
                      className="rounded-pill"
                      required={validFechaDoc}
                      // defaultValue={edit ? editItem.pais_nacimiento : null}
                      placeholder="Descripción del documento"
                      disabled={!habilitarFecha}
                    >
                      <option value="" selected disabled>
                        Seleccione un descripción
                      </option>
                      {subNiveles &&
                        subNiveles.subNivelDescripcionList &&
                        subNiveles.subNivelDescripcionList.map(
                          (item, index) => (
                            <option key={index} value={item.descripcion}>
                              {item.descripcion}
                            </option>
                          )
                        )}
                    </Form.Control>
                    <Form.Control.Feedback type="invalid">
                      **Campo requerido
                    </Form.Control.Feedback>
                  </Col>
                </Form.Group>
                <Form.Group as={Row} className="mb-3">
                  <Form.Label column sm="12" md="4">
                    Fecha de entrega
                  </Form.Label>
                  <Col sm="12" md="8">
                    <Form.Control
                      name="fechaDoc"
                      className="rounded-pill"
                      required={validFechaDoc}
                      type="date"
                      placeholder="Descripción"
                      disabled={!habilitarFecha}
                    ></Form.Control>
                    <Form.Control.Feedback type="invalid">
                      **Campo requerido
                    </Form.Control.Feedback>
                  </Col>
                </Form.Group>
              </>
            )}
            {edit && editItem.archivo_gestor ? (
              <>
                <h6 className="text-muted ml-3">Archivo actual</h6>
                <ul className="list-unstyled">
                  <LinkDescargaGD
                    id={editItem.id}
                    filters={{
                      email: email,
                      id: editItem.archivo_gestor[0].id_documento,
                      llave: editItem.archivo_gestor[0].llave,
                    }}
                    origen={editItem.archivo_gestor[0].origen}
                    cType={editItem.archivo_gestor[0].contentTypeGD}
                  />
                </ul>
              </>
            ) : null}
          </Modal.Body>
          <Modal.Footer>
            <Button
              className="rounded-pill"
              variant="secondary"
              onClick={() => setShowModal(false)}
            >
              Cerrar
            </Button>
            <Button
              className="rounded-pill"
              disabled={saveLoading}
              variant="primary"
              type="submit"
            >
              {saveLoading ? (
                <Spinner
                  className="mr-2"
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />
              ) : null}
              Guardar
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </>
  );
};

export default forwardRef(UserEducationComponent);
